import './App.css';
import { ExerciseContract, Spinner } from '@datacamp/campus-integration';
import { createTranslationsInstance } from '@datacamp/exercise-library-translation-utils';
import * as React from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import CommunicationContainer from './containers/CommunicationContainer';
import EntityProvider from './containers/EntityProvider';
import ExerciseLoader from './containers/ExerciseLoader';
import MultipleChoiceExercise from './containers/MultipleChoiceExercise';
import NormalExercise from './containers/NormalExercise';
import WaitForLogin from './containers/WaitForLogin';
import WorkbookLoader from './containers/WorkbookLoader';
import { isMultipleChoiceExercise, isNormalExercise } from './interfaces/IExercise';
import glossaryDe from './locales/de-DE/glossary.json';
import de from './locales/de-DE/translation.json';
import glossaryEn from './locales/en/glossary.json';
import en from './locales/en/translation.json';
import glossaryEs from './locales/es/glossary.json';
import es from './locales/es/translation.json';
import glossaryFr from './locales/fr-FR/glossary.json';
import fr from './locales/fr-FR/translation.json';
import glossaryIt from './locales/it-IT/glossary.json';
import it from './locales/it-IT/translation.json';
import glossaryPt from './locales/pt-BR/glossary.json';
import pt from './locales/pt-BR/translation.json';
import glossaryTr from './locales/tr-TR/glossary.json';
import tr from './locales/tr-TR/translation.json';
import reducers from './reducers';
import { jsx as ___EmotionJSX } from "@emotion/react";
const composeEnhancers = compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));
export const translations = {
  de: {
    glossary: glossaryDe,
    translation: de
  },
  en: {
    glossary: glossaryEn,
    translation: en
  },
  es: {
    glossary: glossaryEs,
    translation: es
  },
  fr: {
    glossary: glossaryFr,
    translation: fr
  },
  it: {
    glossary: glossaryIt,
    translation: it
  },
  pt: {
    glossary: glossaryPt,
    translation: pt
  },
  tr: {
    glossary: glossaryTr,
    translation: tr
  }
};
const App = _ref => {
  let {
    initialExerciseProps
  } = _ref;
  return ___EmotionJSX(Provider, {
    store: store
  }, ___EmotionJSX(EntityProvider, null, ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ExerciseContract, {
    initialExerciseProps: initialExerciseProps,
    type: "SpreadsheetsExercise"
  }, _ref2 => {
    let {
      callbacks,
      exerciseProps
    } = _ref2;
    if (exerciseProps === undefined) {
      return ___EmotionJSX(Spinner, null);
    }
    const {
      environment,
      id,
      user
    } = exerciseProps;
    const i18n = createTranslationsInstance({
      language: user === null || user === void 0 ? void 0 : user.language,
      resources: translations
    });
    return id === undefined ? null : ___EmotionJSX(WaitForLogin, {
      environment: environment
    }, ___EmotionJSX(ExerciseLoader, {
      environment: environment,
      exerciseId: id
    }, _ref3 => {
      let {
        exercise
      } = _ref3;
      return ___EmotionJSX(WorkbookLoader, {
        environment: environment,
        exercise: exercise
      }, _ref4 => {
        let {
          resetWorkbook,
          workbook,
          workbookReady
        } = _ref4;
        return ___EmotionJSX(I18nextProvider, {
          i18n: i18n
        }, ___EmotionJSX(CommunicationContainer, {
          exercise: exercise,
          exerciseId: id,
          onExerciseReady: callbacks.onExerciseReady,
          onExerciseStatusUpdate: callbacks.onExerciseStatusUpdate,
          onExerciseSubmitted: callbacks.onExerciseSubmitted,
          onXpUpdated: callbacks.onXpUpdated,
          workbook: workbook
        }), isNormalExercise(exercise) && ___EmotionJSX(NormalExercise, {
          environment: environment,
          exercise: exercise,
          exerciseId: id,
          onExerciseFinished: callbacks.onExerciseFinished,
          resetWorkbook: resetWorkbook,
          workbook: workbook,
          workbookReady: workbookReady
        }), isMultipleChoiceExercise(exercise) && ___EmotionJSX(MultipleChoiceExercise, {
          environment: environment,
          exercise: exercise,
          exerciseId: id,
          onExerciseFinished: callbacks.onExerciseFinished,
          resetWorkbook: resetWorkbook,
          workbook: workbook,
          workbookReady: workbookReady
        }));
      });
    }));
  }))));
};
export default App;